var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack517({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.13,10.68v-1h2.5V12a3.19,3.19,0,0,1-1.06.62,3.74,3.74,0,0,1-1.39.27,3.17,3.17,0,0,1-1.57-.38,2.41,2.41,0,0,1-1-1.07A3.43,3.43,0,0,1,5.27,9.9a3.28,3.28,0,0,1,.38-1.59A2.56,2.56,0,0,1,6.74,7.24,3,3,0,0,1,8.12,7a2.71,2.71,0,0,1,1.66.45,2,2,0,0,1,.77,1.23L9.4,8.86A1.22,1.22,0,0,0,9,8.19,1.38,1.38,0,0,0,8.12,8a1.57,1.57,0,0,0-1.21.48,2,2,0,0,0-.45,1.42,2.2,2.2,0,0,0,.46,1.53,1.49,1.49,0,0,0,1.18.51,2.06,2.06,0,0,0,.73-.14,2.35,2.35,0,0,0,.63-.35v-.72Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack517);
export default __webpack_public_path__ + "static/media/Symbolpack_5_17.11602d84b8d44ce9ae30bbf5188b66f5.svg";
export { ForwardRef as ReactComponent };